/**
 * Atrapa los errores inesperados al dibujar la app (un componente que se rompe) y muestra la pantalla 500 en vez de una
 * pantalla en blanco. No atrapa errores de eventos ni de pedidos al servidor (esos los maneja cada pantalla) ni los 401/403
 * de la API (los maneja utils/configurarAxios.js): este es solo el último recurso.
 * No manda nada al servidor: deja el detalle en la consola del navegador.
 */
import React from 'react';
import PaginaError from './PaginaError';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { fallo: false };
  }

  static getDerivedStateFromError() {
    return { fallo: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Error inesperado en la app:', error, info && info.componentStack);
  }

  render() {
    if (this.state.fallo) return <PaginaError tipo={500} />;
    return this.props.children;
  }
}

export default ErrorBoundary;
